import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";
import type { Period } from "../../generated/core-api";

export function useCompletionTimeseries(
  fromDate: string,
  toDate: string,
  period: Period,
) {
  return useQuery({
    queryKey: [
      "platformAnalytics",
      "completionTimeseries",
      fromDate,
      toDate,
      period,
    ],
    queryFn: () =>
      api.getCompletionTimeseries({
        from_date: fromDate,
        to_date: toDate,
        period,
      }),
  });
}
